import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatChipsModule } from '@angular/material/chips';
import {
  NgbAccordionModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgChartsModule } from 'ng2-charts';
import { CountdownModule } from 'ngx-countdown';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { ProcessAutoComponent } from '../shared/widget/websocket/process-auto.component';
import { WidgetModule } from '../shared/widget/widget.module';
import { AdminComponent } from './admin/admin.component';
import { InfosComponent } from './infos/infos.component';
import { LoganStatusComponent } from './logan-status/logan-status.component';
import { OtherModule } from './other/other.module';
import { PacketsModule } from './packets/packets.module';
import { PagesRoutingModule } from './pages-routing.module';
import { ToolsModule } from './tools/tools.module';
import { VanTransferModule } from './van-transfer/van-transfer.module';
import { ReportModule } from './report/report.module';

@NgModule({
  declarations: [
    LoganStatusComponent,
    AdminComponent,
    InfosComponent,
    ProcessAutoComponent,
  ],
  imports: [
    CommonModule,
    ToolsModule,
    OtherModule,
    VanTransferModule,
    ReportModule,
    SharedModule,
    WidgetModule,
    PacketsModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    PagesRoutingModule,
    NgxPaginationModule,
    NgbTooltipModule,
    MatChipsModule,
    NgChartsModule,
    NgbNavModule,
    NgbAccordionModule,
    GoogleMapsModule,
  ],
  providers: [],
})
export class PagesModule {}
